/**
 * エラーコードの定数定義
 */
export const ErrorCodeConstants = {
  // エラーコード一覧(4桁目'6'とする)
  ERROR_CODES: {
    EAPZ000001: 'EAP6000001',
    EAPZ000003: 'EAP6000003',
    EAPZ000004: 'EAP6000004',
    EAPZ000009: 'EAP6000009',
    EAPZ000010: 'EAP6000010',
    EAPZ000018: 'EAP6000018',
    EAPZ000019: 'EAP6000019',
    EAPZ000020: 'EAP6000020',
    EAPZ000050: 'EAP6000050',
    EAPZ000051: 'EAP6000051',
    EBAA000002: 'EBA6100002',
    EBAA000003: 'EBA6100003',
    EBAZ000004: 'EBA6000004',
    EBAZ000005: 'EBA6000005',
    EBAZ000006: 'EBA6000006',
    EBAZ000007: 'EBA6000007',
    EBAZ000008: 'EBA6000008',
    EBAZ000009: 'EBA6000009',
    EBAZ000010: 'EBA6000010',
    EBAZ000011: 'EBA6000011',
    EBAZ000012: 'EBA6000012',
    EBAZ000013: 'EBA6000013',
    EBAZ000015: 'EBA6000015',
    EBAZ000104: 'EBA6000104',
    EBAZ000109: 'EBA6000109',
    EBAZ000111: 'EBA6000111',
    EBAZ000112: 'EBA6000112',
    EBAZ000113: 'EBA6000113',
    EBAZ000114: 'EBA6000114',
    EBAZ000115: 'EBA6000115',
    EBAZ000116: 'EBA6000116',
    EBAZ000117: 'EBA6000117',
    EBAZ000119: 'EBA6000119',
    EBAZ000120: 'EBA6000120',
    EBAZ000121: 'EBA6000121',
    EBAZ000122: 'EBA6000122',
    EBAZ000123: 'EBA6000123',
    EBAZ000124: 'EBA6000124',
    EBAZ000126: 'EBA6000126',
    EBAZ000127: 'EBA6000127',
    EBAZ000128: 'EBA6000128',
    EBAZ000293: 'EBA6000293',
    EBAZ000294: 'EBA6000294',
    EBAZ000319: 'EBA6000319',
    EBAZ000322: 'EBA6000322',
    EBAZ000349: 'EBA6000349',
    EBAZ000350: 'EBA6000350',
    EBAZ000351: 'EBA6000351',
    EBAZ000353: 'EBA6000353',
    EBAZ000355: 'EBA6000355',
    EBAZ000357: 'EBA6000357',
    EBAZ000358: 'EBA6000358',
    EBAZ000359: 'EBA6000359',
    EBAZ000363: 'EBA6000363',
    EBAZ000364: 'EBA6000364',
    EBAZ000379: 'EBA6000379',
    EBAZ000397: 'EBA6000397',
    EBAZ000398: 'EBA6000398',
    EBAZ000399: 'EBA6000399',
    EBAZ000496: 'EBA6000496',
    EBAZ000619: 'EBA6000619',
    EBAZ000644: 'EBA6000644',
    EBAZ000645: 'EBA6000645',
    EBAZ000647: 'EBA6000647',
    EBAZ000656: 'EBA6000656',
    EBAZ000721: 'EBA6000721',
    EBAZ000723: 'EBA6000723',
    EBAZ000731: 'EBA6000731',
    EBAZ000732: 'EBA6000732',
    EBAZ000733: 'EBA6000733',
    EBAZ000734: 'EBA6000734',
    EBAZ000774: 'EBA6000774',
    EBAZ000776: 'EBA6000776',
    EBAZ000781: 'EBA6000781',
    EBAZ000811: 'EBA6000811',
    EBAZ000812: 'EBA6000812',
    EBAZ000814: 'EBA6000814',
    EBAZ000816: 'EBA6000816',
    EBAZ000818: 'EBA6000818',
    EBAZ000819: 'EBA6000819',
    EBAZ000823: 'EBA6000823',
    EBAZ000892: 'EBA6000892',
    EBAZ000909: 'EBA6000909',
    EBAZ000999: 'EBA6000999',
    EIFA000001: 'EIF6100001',
    EIFA000002: 'EIF6100002',
    EIFA000003: 'EIF6100003',
    EIFA000004: 'EIF6100004',
    EIFA000005: 'EIF6100005',
    EIFA000006: 'EIF6100006',
    EIFA000007: 'EIF6100007',
    EIFA000008: 'EIF6100008',
    EIFA000009: 'EIF6100009',
    EIFA000011: 'EIF6100011',
    EIFA000012: 'EIF6100012',
    EIFA000013: 'EIF6100013',
    EIFA000014: 'EIF6100014',
    EIFA000015: 'EIF6100015',
    EIFA000016: 'EIF6100016',
    FDXZ000005: 'FDX6000005',
    FIFA000001: 'FIF6100001',
  },
};

/**
 * ワーニングコードの定数定義
 */
export const WarningCodeConstants = {
  // ワーニングコード一覧(4桁目'6'とする)
  WARNING_CODES: {
    WBAZ000046: 'WBA6000046',
    WBAZ000047: 'WBA6000047',
    WBAZ000247: 'WBA6000247',
    WBAZ000252: 'WBA6000252',
    WBAZ000255: 'WBA6000255',
    WBAZ000570: 'WBA6000570',
    WBAZ000578: 'WBA6000578',
    WBAZ000579: 'WBA6000579',
    WBAZ000580: 'WBA6000580',
    WBAZ000581: 'WBA6000581',
    WBAZ000582: 'WBA6000582',
  },
};

/**
 * 共通処理で利用する定数の定義
 */
export const CommonConstants = {
  THREE_LETTER: 'SNJ',
  TWO_LETTER: '6J',
  // オフィスコードチェック用定数
  OFFICE_CODE_JP: 'KMI6J08', // 日本統合オフィスコード
  OFFICE_CODE_JP_R: 'KMI6J08AA', // 有償日本オフィス
  OFFICE_CODE_JP_R_APF: '', // 有償日本オフィスAPF
  OFFICE_CODE_JP_A: 'KMI6J08ZZ', // 特典日本オフィス
  // 提携3社ログインモーダルで(ADO,SFJ,SNJ)会員番号チェック用定数
  MEMBER_NUMBER_RULES: {
    type: 'numberic' as 'alphaNumberic' | 'numberic',
    length: 12,
  },
  // ログインモーダルのパスワードチェック用定数
  PASSWORD_RULES: {
    minPwLength: 8,
    maxPwLength: 12,
    pwRegex: '^[a-zA-Z0-9-_.+$#!/@(%&*?)]*$',
  },
  // ログイン情報連携機能が有効か
  LOGIN_INFO_INTEGRATION_ENABLED: true,
  // 提携社サイトに戻る際のURL切り替え機能が有効か
  RETURN_URL_SWITCH_ENABLED: true,
  LOGO_FILE_PATH: 'assets/images/logo_snj.svg',
  LOGO_S_FILE_PATH: 'assets/images/logo_snj_s.svg',
  // 法人ヘッダー用ロゴファイルパス
  LOGO_BIZ_FILE_PATH: 'assets/images/logo_snj_biz.svg',
  // ログインAPIエラーコードMAP
  LOGIN_API_ERROR_MAP: {
    [ErrorCodeConstants.ERROR_CODES.EIFA000001]: 'EA021', // ログイン情報なし
    [ErrorCodeConstants.ERROR_CODES.EIFA000002]: 'EA022', // ログイン情報が無効
    [ErrorCodeConstants.ERROR_CODES.EIFA000003]: 'EA014', // 一定時間内のログイン試行回数超過によりブロックされた会員
    [ErrorCodeConstants.ERROR_CODES.EIFA000004]: 'EA020', // パスワード不一致
    [ErrorCodeConstants.ERROR_CODES.EIFA000005]: 'EA013', // パスワード有効期限切れ
    [ErrorCodeConstants.ERROR_CODES.EIFA000006]: 'EA016',
    [ErrorCodeConstants.ERROR_CODES.EIFA000007]: 'EA023',
    [ErrorCodeConstants.ERROR_CODES.EIFA000008]: 'EA024',
    [ErrorCodeConstants.ERROR_CODES.EIFA000009]: 'EA017',
    [ErrorCodeConstants.ERROR_CODES.EIFA000011]: 'EA015',
    [ErrorCodeConstants.ERROR_CODES.EIFA000012]: 'EA021',
    [ErrorCodeConstants.ERROR_CODES.EIFA000013]: 'EA021',
    [ErrorCodeConstants.ERROR_CODES.EIFA000014]: 'EA020',
    [ErrorCodeConstants.ERROR_CODES.EIFA000015]: 'EA018',
    [ErrorCodeConstants.ERROR_CODES.EIFA000016]: 'EA025',
    [ErrorCodeConstants.ERROR_CODES.EBAA000002]: 'EA050', // 会員区分が無効会員の場合
    [ErrorCodeConstants.ERROR_CODES.EBAA000003]: 'EA051', // 認証結果がfalse
    [ErrorCodeConstants.ERROR_CODES.EAPZ000009]: 'E0361', // 搭乗者に含まれているかチェック
    [ErrorCodeConstants.ERROR_CODES.EAPZ000010]: 'E0361', // マイル減算者の会員かチェックエラー
    [ErrorCodeConstants.ERROR_CODES.FIFA000001]: 'EA019', // ifly接続エラー(想定外エラー)
  } as { [key: string]: string },
  INLINETELEMETRY_URL: {
    AUTH_LOGIN: {
      ENDPOINT: /\/all-.*-member\/api\/.*\/auth-login/,
      METHOD: 'POST',
    },
    PAYMENT_RECORD: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/payment-records/,
      METHOD: 'POST',
    },
    CREATE_ORDER: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/create-order/,
      METHOD: 'POST',
    },
    CAPTCHA_AUTHENTICATION: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/captcha-authentication$/,
      METHOD: 'POST',
    },
    CREATE_CART: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/carts\/create-cart/,
      METHOD: 'POST',
    },
    ROUNDTRIP_FPP: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/roundtrip-fpp/,
      METHOD: 'POST',
    },
  } as { [key: string]: { ENDPOINT: RegExp; METHOD: string } },
} as const;

/**
 * APP内で利用する定数の定義
 */
export const AppConstants = {
  IMG: {
    // 全体
    ALL_EXTERNAL_PRIMARY: 'assets/images/icon_external_snj_green_16.svg',
    ALL_EXTERNAL_RED: 'assets/images/icon_external_snj_red_dark_16.svg',
    ALL_HELP_PRIMARY: 'assets/images/icon_help_snj_green_24.svg',
    ALL_CHECKINSTATUS_NOTACCEPTED: 'assets/images/icon_remove_snj_green_20.svg',
    ALL_CHECKINSTATUS_ACCEPTED: 'assets/images/icon_feature_available_snj_blue_dark_24.svg',
    // C01-P040-S01-U チェックインシートマップ
    C01_P040_S01_U_SEATMAP_FLOAT_LEGEND: 'assets/images/seatmap_float_legend_snj.svg',
    C01_P040_S01_U_SEATMAP_FLOAT_SEATTYPE: 'assets/images/seatmap_float_seattype_snj.svg',
    C01_P040_S01_U_LEGENDS_SEAT_SELECTED: 'assets/images/seat_selected_snj_24.svg',
    C01_P040_S01_U_LEGENDS_SEAT_BEFORE_CHANGE_FREE_SEAT: 'assets/images/seat_before_change_free_seat_snj_24.svg',
    C01_P040_S01_U_LEGENDS_EMERGENCY_EXIT_SEAT: 'assets/images/seat_emergency_exit_seat_snj_24.svg',
    C01_P040_S01_U_LEGENDS_SEAT_LAVATORY: 'assets/images/seat_lavatory_snj_24.svg',
    C01_P040_S01_U_LEGENDS_GALLEY: 'assets/images/seat_galley_snj_24.svg',
    C01_P040_S01_U_LEGENDS_WING: 'assets/images/seat_wing_snj_24.svg',
  },
  ABLE_D_TRANSITION_PARAMETER: {
    EXTERNAL_FLG: 'NEWSNA',
    ALLIANCE_FLG: 'SNA',
  },
} as const;
